import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'

SOPHIA.sendXHR = function(data, cb, focusElement, showPreloaderOpt) {
  var showPreloader = (typeof showPreloaderOpt != 'undefined') ? showPreloaderOpt : true;

  // extend callbacks with default settings
  var callbacks = $.extend({
    handle_messages: function(flash)  {
      if (flash.notice) {
        SOPHIA.flashMessage( flash.notice, 'success' );
      } else if (flash.warning) {
        SOPHIA.modalMessage(flash.warning, 'error', focusElement);
      } else if (flash.error) {
        SOPHIA.modalMessage(flash.error, 'error', focusElement);
      } else if (flash.success){
        setTimeout(function(){
          SOPHIA.modalMessage(flash.success, 'success', focusElement);
        }, 400);
      }
    },
    redirect: function(response) {
      window.location = response.location;
    }
  }, cb);

  // extend xhr parameters with default settings
  var xhrData = $.extend({
    showPreloader: showPreloader,
    complete: function(response) {
      if(callbacks.afterComplete) {
        callbacks.afterComplete(response);
      }
    }
  }, data);

  // Send Data
  return SOPHIA.ajax(xhrData).then(
    function(response, status, xhr) {
      if ( typeof focusElement != 'undefined' ) focusElement.trigger('focus');

      if (response && 'object' === typeof response) {
        if (response.flash && !_.isEmpty(response.flash)) {
          callbacks.handle_messages(response.flash);
        } else if (response.location) {
          callbacks.redirect(response);
        }
      }

      if (callbacks.afterSuccess) {
        callbacks.afterSuccess(response);
      }

      return Promise.resolve(response, status, xhr);
    },
    function(xhr, status, error) {
      if ( callbacks.afterError ) {
        // Do not make default actions if callback returns false
        if (false === callbacks.afterError(xhr, status, error)) return;
      }

      if (xhr.status == 403) { // Forbidden
        window.location.reload();
      } else if (xhr.status != 422) {
        SOPHIA.xhrErrorModal();
      }

      return Promise.reject(xhr, status, error);
    }
  )
};

SOPHIA.xhrHasErrors = function(response) {
  return !!(
    (response.flash && (response.flash.warning || response.flash.error)) ||
    (response.errors && !_.isEmpty(response.errors))
  )
};

SOPHIA.isIos = function() {
  return navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/iPad/i);
};

SOPHIA.isMobileDevice = function() {
  return /Android|webOS|iPhone|iPad|iPod|pocket|psp|kindle|avantgo|blazer|midori|Tablet|Palm|maemo|plucker|phone|BlackBerry|symbian|IEMobile|mobile|ZuneWP7|Windows Phone|Opera Mini/i.test(navigator.userAgent);
};

SOPHIA.xhrErrorModal = function() {
  SOPHIA.modalMessage(
    'We could not process your request at this time. Please try again later.',
    'error'
  );
};

Backbone.ajax = SOPHIA.ajax;
